var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.172 8.825 8.081 7.256V4.061a.58.58 0 1 0-1.162 0v3.486a.58.58 0 0 0 .232.464l2.324 1.743a.578.578 0 0 0 .813-.117.58.58 0 0 0-.116-.812Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.364 0 0 3.364 0 7.5S3.364 15 7.5 15 15 11.636 15 7.5 11.636 0 7.5 0Zm0 13.838A6.346 6.346 0 0 1 1.162 7.5 6.346 6.346 0 0 1 7.5 1.162 6.345 6.345 0 0 1 13.838 7.5 6.346 6.346 0 0 1 7.5 13.838Z",
    fill: "#fff"
  })));
};
export default SvgClock;